// src/components/Payment/addbanner.js
import React from 'react';

const Odhpaymoneymember = () => {
  return (
    <div>
      <h2>Odhpaymoneymember</h2>
      <p>This is the addbanner component.</p>
    </div>
  );
};

export default Odhpaymoneymember;
